import { forwardRef, InputHTMLAttributes } from 'react'

const RangeInput = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement>
>((props, ref) => {
  return <input type="range" className="calc-slider" ref={ref} {...props} />
})

RangeInput.displayName = 'RangeInput'

export default RangeInput
